import { render } from "./DatepickerPage.vue?vue&type=template&id=2476a5de&ts=true"
import script from "./DatepickerPage.vue?vue&type=script&lang=ts"
export * from "./DatepickerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__